import {FC, useContext} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {AdminHeader} from "../../AdminHeader";
import {useNavigate} from "react-router-dom";
import {IAdminUsersQuizzesResponseEntry, ILocalizationEntity} from "@buildwitt/shapeshift-types";
import {useApi} from "@buildwitt/shapeshift-identity";
import {AdminTable, AdminTableProps} from "@/components/common/table";
import {GRID_CHECKBOX_SELECTION_COL_DEF} from "@mui/x-data-grid-pro";
import {PageBaseContext} from "../../../../contexts/pageBaseContext";
import useDevCycleSdk from "@/hooks/useDevCycleSdk";

const useStyles = makeStyles()((_theme) => ({
	adminQuizzesList: {
		"& th": {
			fontSize: "11px",
			fontWeight: 700,
			textTransform: "uppercase"
		}
	}
}));

const headCells = (locales?: ILocalizationEntity[], ownedCohortTitle?: string): AdminTableProps<"quiz", IAdminUsersQuizzesResponseEntry>["columns"] => ([
	{
		...GRID_CHECKBOX_SELECTION_COL_DEF,
		type: "string",
		hideable: false
	},
	{
		field: "title",
		type: "string",
		flex: 1,
		headerName: "Quiz",
		minWidth: 240
	},
	{
		field: "publishedAt",
		type: "date",
		flex: 1,
		headerName: "Published",
		width: 100,
		valueGetter: (e) => e.value ? new Date(e.value).toLocaleDateString() : ""
	},
	{
		field: "languages",
		type: "string",
		filterable: false,
		flex: 1,
		headerName: "Supported Languages",
		valueGetter: ({value}: {value: IAdminUsersQuizzesResponseEntry["languages"]}) => value?.map(e => locales?.find(x => x.code === e)?.name)?.join(", ")
	}
	// {
	// 	field: "authorCohort",
	// 	type: "string",
	// 	flex: 1,
	// 	filterable: false,
	// 	headerName: "Shared By",
	// 	valueGetter: ({value}: {value: IAdminUsersQuizzesResponseEntry["authorCohort"]}) => (value?.title ?? "") === ownedCohortTitle ? "" : value?.title
	// }
]);

export const AdminQuizzesList: FC = () => {
	const {classes} = useStyles();
	const navigate = useNavigate();
	const [locales] = useApi<ILocalizationEntity[]>("/api/settings/i18n");
	const [{ownedCohort}] = useContext(PageBaseContext)
	const {hideCreationButtons} = useDevCycleSdk();

	return (
		<Box className={classes.adminQuizzesList}>
			<AdminHeader
				title="Quizzes"
				subtitle="Manage quizzes"
				actionButtons={hideCreationButtons ? undefined : [{label: "Create New", onClick: () => navigate("create")}]}
			/>
			<AdminTable<"quiz", IAdminUsersQuizzesResponseEntry>
				url="/api/strapi-plugin-shapeshift-lms/cohort/quiz"
				columns={headCells(locales.data, typeof ownedCohort === "object" ? ownedCohort?.title : undefined)}
				enableDelete
				type="quiz"
				filterSettingsPersistenceStorageKey="quizFilterSettings"
				onEditAction={e => navigate(e.id.toString())}
			/>
		</Box>
	);
}
